import { logout } from '@shared/api/authentication';
import { notify } from '@shared/components/Notifications/utils';
import config from '@shared/config';
import { IFRAME_EVENT } from '@shared/constants/iframeEvents';
import { isTransformedMainMessageError } from '@shared/containers/hooks/api/utils';

import { newLoginEnabled } from '@ManagerPortal/featureToggles';

import { postMessageToParent } from '../embedded';
import { getCompanyAlias } from '../groups';
import { postMessageToWebView } from '../webView';

export const redirectToLogin = () => {
  const companyAlias = getCompanyAlias();

  const redirectUrl = new URL(
    (newLoginEnabled ? config.login_baseurl : window.location.origin) || '',
  );
  if (companyAlias) {
    redirectUrl.pathname += companyAlias;
  }
  window.location.assign(redirectUrl.toString());
};

export const logoutWithRedirect = () => {
  logout()
    .then((response) => {
      postMessageToWebView('LOGOUT');
      postMessageToParent({ event: IFRAME_EVENT.LOGOUT });

      if (response && response.text) {
        window.location.href = response.text;
      } else {
        redirectToLogin();
      }
    })
    .catch((error) => {
      if (isTransformedMainMessageError(error)) {
        notify(error.errors.mainMessage);
      } else {
        throw error;
      }
    });
};
